import STYLE_MANAGER from "../../../style-manager";

export class RedoBackInStockContainerElement extends HTMLElement {
  #deregisterStyles?: () => void;
  #root!: ShadowRoot;

  get root() {
    return this.#root;
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "open" });
    this.#root = shadowRoot;
    this.#deregisterStyles = STYLE_MANAGER.register(shadowRoot);
  }

  disconnectedCallback() {
    this.#deregisterStyles?.();
  }

  static #registered = false;

  static register() {
    if (!this.#registered) {
      customElements.define(this.TAG, this);
      this.#registered = true;
    }
  }

  static readonly TAG = "redo-back-in-stock-container-element";
}
